
export const PATH_PENDING = "PATH_PENDING";
export const PATH = "PATH";
export const PATH_FAILED = "PATH_FAILED";


export const RESET_PATH = "RESET_PATH";